// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/system';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import stylesDef from './styles';

export type ProjectsMapView = 'projects' | 'map';

interface IProjectsMapToggleProps {
  value: ProjectsMapView;
  onChange: (view: ProjectsMapView) => void;
}

// The Figma's two-segment Projects / Map switch. Presentational: the dashboard's search row
// shows it with Projects active, the map rail with Map active, and each decides what switching
// does. Clicking the segment that is already active is not a change.
export const ProjectsMapToggle = ({ value, onChange }: IProjectsMapToggleProps) => {
  const theme = useTheme();
  const styles = stylesDef(theme);

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      aria-label="Projects or map"
      sx={styles.track}
      onChange={(_event, next: ProjectsMapView | null) => {
        // MUI hands back null when the active segment is clicked again
        if (next && next !== value) onChange(next);
      }}
    >
      <ToggleButton value="projects" aria-label="Projects" sx={styles.segment}>
        <GridViewOutlinedIcon sx={styles.segmentIcon} />
        <Box component="span" sx={styles.segmentLabel}>Projects</Box>
      </ToggleButton>
      <ToggleButton value="map" aria-label="Map" sx={styles.segment}>
        <LocationOnOutlinedIcon sx={styles.segmentIcon} />
        <Box component="span" sx={styles.segmentLabel}>Map</Box>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ProjectsMapToggle;
